export default "/images/vendor/flag-icon-css/flags/1x1/bz.svg?fb56b21728994fd6b18ff83122f2370c";